{
  "sidebar.navigationLabel": "Primary navigation",
  "sidebar.themeToggleLight": "Switch to light mode",
  "sidebar.themeToggleDark": "Switch to dark mode",
  "nav.main": "Main sections",
  "welcome.mapAria": "Interactive field boundary map",
  "welcome.locating": "Finding your location...",
  "welcome.drawButtonAria": "Draw a new field boundary",
  "welcome.drawingHintKeyboard": "Press Escape to cancel drawing.",
  "welcome.drawingLiveArea": "Estimated area: {area}",
  "welcome.drawingHintTouch": "Tap to place points. Tap the first point to close.",
  "welcome.drawingHintTouchPan": "Use two fingers to pan the map.",
  "welcome.drawingToolbarAria": "Drawing tools",
  "welcome.undoVertexAria": "Undo last point",
  "welcome.finishPolygonAria": "Close polygon and finish drawing",
  "welcome.cancelDrawingAria": "Cancel drawing",
  "welcome.undo": "Undo",
  "welcome.finish": "Finish",
  "advisor.inputAria": "Ask the advisor a question",
  "advisor.runSelectLabel": "Select a saved simulation run",
  "advisor.deleteRun": "Delete saved run",
  "advisor.confirmDeleteRun": "Delete this saved run?",
  "advisor.runDeleted": "Saved run deleted.",
  "satellite.ndviChartAria": "NDVI time series chart",
  "satellite.ndviMean": "NDVI mean",
  "field.dialogTitle": "Save New Field",
  "field.dialogArea": "Estimated area: {size}",
  "field.dialogName": "Field name",
  "field.dialogNamePlaceholder": "Enter a field name",
  "field.dialogCrop": "Crop",
  "field.dialogSaving": "Saving...",
  "field.dialogSave": "Save Field",
  "kpi.groupLabel": "Field performance summary",
  "kpi.ariaYield": "Estimated yield {value}",
  "kpi.ariaProfit": "Estimated profit {value}",
  "kpi.ariaHealth": "Field health {value}",
  "kpi.ariaCaptured": "Last captured image {value}",
  "sidebar.title": "AGROPTIMIZER",
  "sidebar.subtitle": "Field Intelligence System",
  "sidebar.lightMode": "Light Mode",
  "sidebar.darkMode": "Dark Mode",
  "sidebar.logout": "Logout",
  "sidebar.drawField": "+ Draw New Field",
  "sidebar.yourFields": "Your Fields",
  "sidebar.yourFieldsAria": "Open fields list",
  "sidebar.units.imperial": "Imperial",
  "sidebar.units.metric": "Metric",
  "sidebar.sessionLanguage": "Language",
  "sidebar.sessionUnits": "Measurement Units",
  "common.retry": "Retry",
  "common.close": "Close",
  "common.cancel": "Cancel",
  "prefs.unitsLabel": "Measurement Units",
  "prefs.languagePlaceholder": "Select language",
  "prefs.unitsPlaceholder": "Select units",
  "prefs.language.english": "English (US)",
  "prefs.language.greek": "Ελληνικά",
  "prefs.language.portuguese": "Português (Brasil)",
  "prefs.language.spanish": "Español",
  "prefs.required": "Choose both your language and your measurement units before continuing.",
  "params.title": "Simulation Config",
  "params.fieldConditions": "Field Conditions",
  "params.irrigation": "Irrigation",
  "params.irrigation.rainfed": "Rainfed",
  "params.irrigation.irrigated": "Irrigated",
  "params.prevCrop": "Prev Crop",
  "params.prevCrop.corn": "Corn",
  "params.prevCrop.soybean": "Soybean",
  "params.prevCrop.wheat": "Wheat",
  "params.prevCrop.rice": "Rice",
  "params.prevCrop.cotton": "Cotton",
  "params.prevCrop.fallow": "Fallow",
  "params.prevCrop.sorghum": "Sorghum",
  "params.prevCrop.otherCereal": "Other Cereal",
  "params.prevCrop.otherLegume": "Other Legume",
  "params.prevCrop.smallGrains": "Small Grains",
  "params.prevCrop.other": "Other",
  "params.soilType": "Soil Type",
  "params.soilType.siltLoam": "Silt Loam",
  "params.soilType.sandyLoam": "Sandy Loam",
  "params.soilType.clayLoam": "Clay Loam",
  "params.soilType.siltyClayLoam": "Silty Clay Loam",
  "params.soilType.loamySand": "Loamy Sand",
  "params.soilType.loam": "Loam",
  "params.soilType.clay": "Clay",
  "params.soilType.sand": "Sand",
  "params.soilType.silt": "Silt",
  "params.soilType.sandyClayLoam": "Sandy Clay Loam",
  "params.soilType.siltyClay": "Silty Clay",
  "params.soilType.muck": "Muck",
  "params.soilOM": "Soil OM (%)",
  "params.soilPH": "Soil pH",
  "params.phosphorus": "Phosphorus",
  "params.phosphorus.high": ">50 ppm",
  "params.phosphorus.medium": "36–50 ppm",
  "params.phosphorus.low": "25–35 ppm",
  "params.phosphorus.veryLow": "<25 ppm",
  "params.potassium": "Potassium",
  "params.potassium.high": ">175 ppm",
  "params.potassium.medium": "131–175 ppm",
  "params.potassium.low": "61–130 ppm",
  "params.potassium.veryLow": "<61 ppm",
  "params.management": "Management Strategy",
  "params.plantMonth": "Plant Month",
  "params.month.january": "January",
  "params.month.february": "February",
  "params.month.march": "March",
  "params.month.april": "April",
  "params.month.may": "May",
  "params.month.june": "June",
  "params.month.july": "July",
  "params.month.august": "August",
  "params.month.september": "September",
  "params.month.october": "October",
  "params.month.november": "November",
  "params.month.december": "December",
  "params.plantDay": "Day",
  "params.maturityGroup": "Maturity Group",
  "params.relativeMaturity": "Relative Maturity (days)",
  "params.seedingRate": "Seeding Rate ({unit})",
  "params.rowSpacing": "Row Spacing ({unit})",
  "params.tillage": "Tillage System",
  "params.tillage.conventional": "Conventional",
  "params.tillage.noTill": "No-Till",
  "params.tillage.stripTill": "Strip-Till",
  "params.foliarFungicide": "Foliar Fungicide",
  "params.seedTreatment": "Seed Treatment",
  "params.foliarFert": "Foliar Fert",
  "params.coverCrop": "Cover Crop",
  "params.apply": "Apply",
  "params.no": "No",
  "params.fertility": "Applied Fertility",
  "params.nitrogen": "Nitrogen ({unit})",
  "params.nitrogenSplit": "Nitrogen Split ({unit})",
  "params.nitrogenTotal": "Total:",
  "params.nitrogenSplitNote": "Total N across all timings cannot exceed {max} lb/ac — adjusting one slider will constrain the others.",
  "params.cornTotalNExceeded": "Total nitrogen {total} lb/ac exceeds the maximum of {max} lb/ac. Reduce one of the N splits before running.",
  "params.nPreSpring": "N Pre-Spring",
  "params.nAtPlant": "N At-Plant",
  "params.nPostPlant": "N Post-Plant",
  "params.phosphorusRate": "Phosphorus ({unit})",
  "params.potassiumRate": "Potassium ({unit})",
  "params.sulfurRate": "Sulfur ({unit})",
  "params.economics": "Economics",
  "params.soybeanPrice": "US reference price (NASS) — soybeans ({unit})",
  "params.cornPrice": "US reference price (NASS) — corn ({unit})",
  "params.seedCostSoy": "Seed Cost ($/140k)",
  "params.seedCostCorn": "Seed Cost ($/80k)",
  "params.fixedCosts": "Fixed Costs ({unit})",
  "params.fixedCosts.tooltip": "Per-acre overhead not tied to a specific input — e.g. land rent, crop insurance, machinery, labor, fuel, repairs.",
  "params.seedTreatmentCost": "Seed Treatment ({unit})",
  "params.coverCropSeed": "Cover Crop Seed ({unit})",
  "params.dryingCost": "Drying Cost ({unit})",
  "params.fertPrices": "Fertilizer Prices ({unit})",
  "params.fertNitrogen": "Nitrogen",
  "params.fertPhosphorus": "Phosphorus",
  "params.fertPotassium": "Potassium",
  "params.fertSulfur": "Sulfur",
  "params.operations": "Operations ({unit})",
  "params.convTillage": "Conv. Tillage",
  "params.noTillPlanting": "No-Till Planting",
  "params.stripTillCost": "Strip-Till",
  "params.applications": "Applications ({unit})",
  "params.fungInsectApp": "Foliar Fungicide/Insecticide Product + Application",
  "params.fertApp": "Fertilizer Application",
  "params.foliarFertApp": "Foliar Fertilizer Product + Application",
  "params.saveEcon": "Save Econ Defaults",
  "params.runSim": "Run Simulation",
  "params.running": "Running...",
  "params.working": "Working...",
  "tabs.advisor": "Advisor",
  "tabs.satellite": "Scout",
  "welcome.title": "No Field Selected",
  "welcome.description": "Draw a field boundary on the satellite map below, or select an existing field from the sidebar to begin your analysis.",
  "welcome.drawBtn": "Draw New Field",
  "advisor.chatPlaceholder": "Ask the agronomist — maximize profit, rank yield drivers, compare tillage systems...",
  "advisor.send": "Send",
  "advisor.welcome": "Hello! I'm your **AI Agronomist**. Configure the parameters on the right panel and run a simulation to get started. I can help you maximize yield, optimize profit, or assess risk across weather scenarios. Or open the **Scout** tab to set up field monitoring and catch problems early.",
  "advisor.engineStarting": "🚜 **Starting the engine...** This typically takes 2–3 minutes.",
  "advisor.paramsInvalid": "Parameters are invalid — please adjust and try again.",
  "advisor.simResults": "**📊 Simulation Results**\n\nEvaluated **{n_scenarios}** scenarios across **{n_weather_years}** weather years.\n\n{'|'} Metric {'|'} Value {'|'}\n{'|'}---{'|'}---{'|'}\n{'|'} Estimated Average Yield {'|'} **{yield_value}** {'|'}\n{'|'} Estimated Profit {'|'} **{profit_value}** {'|'}\n{'|'} Margin per Bushel {'|'} **{margin_value}** {'|'}\n\nAsk me to interpret these results, maximize profit, or rank the top yield drivers.",
  "advisor.simFailed": "❌ Simulation failed: {error}",
  "simulation.completeToast": "Simulation for '{field}' complete — {yield}",
  "simulation.failedToast": "Simulation for '{field}' failed.",
  "advisor.modifyInputs": "Modify Inputs",
  "advisor.hideInputs": "Hide Inputs",
  "advisor.avg": "avg",
  "advisor.noRuns": "No runs yet",
  "satellite.range": "range",
  "satellite.insightAria": "Field health summary",
  "satellite.insight.iconLabel": "Health",
  "satellite.insight.firstImage": "First image of the season — we'll watch for changes over the next few passes.",
  "satellite.insight.noStall": "No stall detected — your field's vegetation signal stayed steady since the last clear image.",
  "satellite.insight.flagged": "{pct}% of the field shows stalled growth since the previous image. The flagged patches are highlighted in red on the map — review their size and location before deciding whether to scout.",
  "satellite.insight.askAdvisor": "Ask Advisor about this image",
  "advisor.autoPrompt.imageAnalysis": "Analyze the satellite image from {date} (DAP {dap}). What changed since the previous image, and what should I look at?",
  "advisor.autoPrompt.imageAnalysisNoDap": "Analyze the satellite image from {date}. What changed since the previous image, and what should I look at?",
  "advisor.autoPrompt.firstImageAnalysis": "This is the first satellite image of the season for this field, from {date} (DAP {dap}). What baseline indicators should I track from here, and what should I look at on this image?",
  "advisor.autoPrompt.firstImageAnalysisNoDap": "This is the first satellite image of the season for this field, from {date}. What baseline indicators should I track from here, and what should I look at on this image?",
  "satellite.state.noField.title": "Select a field to start",
  "satellite.state.noField.body": "Draw or open a field from Your Fields to see satellite monitoring.",
  "satellite.state.awaitingFirstImage.title": "Monitoring active — waiting on the first image",
  "satellite.state.awaitingFirstImage.body": "Waiting for the next Sentinel-2 pass. Your first image should arrive within 5 days after the monitoring start date, if skies are clear. Cloudy passes are skipped, so it may take longer during overcast weather.",
  "satellite.state.monitoringActive.firstImageNote": "First image in. We'll have a trend reading after your next clear pass.",
  "satellite.state.seasonComplete.title": "Season complete",
  "satellite.state.seasonComplete.body": "Your monitoring window has ended. Review the season below, or plan next season in the Advisor.",
  "satellite.state.seasonComplete.cta": "Plan next season",
  "satellite.envelope.preCanopy": "Early canopy — only some indices active. Detection coverage is reduced until the crop closes the canopy (around DAP 30).",
  "satellite.envelope.lateLimited": "Late season — narrowed detection. Some indices have closed their windows; a missing flag here is not a guarantee of zero stress.",
  "satellite.tooltip.stall.firstImage": "First image — no trend yet",
  "satellite.tooltip.stall.none": "No growth stall",
  "satellite.tooltip.stall.pct": "Growth stall: {pct}% of field",
  "satellite.stallRegionsCaption": "Stall growth regions",
  "satellite.kpi.stall.firstImage": "Waiting on trend",
  "satellite.kpi.stall.none": "No stall",
  "satellite.kpi.stall.flagged": "Stall detected",
  "satellite.monitoringTitle": "Field Monitoring",
  "satellite.monitoringSubtitle": "Choose your scouting window. Scouting starts as early as 25 days after planting. You'll see new imagery and insights as they become available during this period.",
  "satellite.monitoringPlantingDate": "Planting date: {date}",
  "satellite.editPlantingDateAria": "Edit planting date",
  "satellite.plantingDateSaveFailed": "Could not save the new planting date. Please try again.",
  "satellite.monitoringRangeLabel": "Scouting window (days after planting)",
  "satellite.monitoringStartLabel": "Start scouting (days after planting)",
  "satellite.monitoringEndLabel": "End scouting (days after planting)",
  "satellite.monitoringStartDate": "Starts: {date}",
  "satellite.monitoringEndDate": "Ends: {date}",
  "satellite.monitoringWindowSummary": "Monitoring window: {start} - {end} ({days} days)",
  "satellite.monitoringLockedSummary": "Monitoring is locked for this field until the scouting window ends.",
  "satellite.endAdjustLabel": "Adjust end of monitoring window",
  "satellite.endAdjustHint": "The planting date and the start of the window are locked because the first satellite image has been captured. You can still move the end of the window forward or back (up to 95 days from the start).",
  "satellite.endAdjustSaving": "Saving...",
  "satellite.endAdjustSaved": "Window updated.",
  "satellite.endAdjustFailed": "Could not update the end of the window. Please try again.",
  "satellite.monitoringStartBtn": "Start Monitoring",
  "satellite.stopMonitoringBtn": "Stop Monitoring",
  "satellite.stopMonitoringConfirmBody": "Stop daily satellite checks for this field? Captured images stay in your history. You can start a new season later.",
  "satellite.stopMonitoringConfirm": "Stop Monitoring",
  "satellite.stopMonitoringSuccess": "Monitoring stopped for this field.",
  "satellite.stopMonitoringFailed": "Could not stop monitoring. Please try again.",
  "satellite.monitoringSeasonEnded": "This season has ended. Adjust the planting date and window above, then start a new season.",
  "satellite.startNewSeason": "Start New Season",
  "satellite.monitoringNotStarted": "Monitoring Not Started",
  "satellite.monitoringScheduled": "Monitoring Scheduled",
  "satellite.monitoringComplete": "Monitoring Complete",
  "satellite.monitoringMissingPlanting": "Choose a planting date in Advisor first.",
  "satellite.latestImage": "Latest Image",
  "satellite.dayAfterPlanting": "Day {dap} after planting",
  "satellite.cloudCover": "Cloud cover",
  "satellite.ndviScale": "NDVI",
  "satellite.monitoringActive": "Monitoring Active",
  "satellite.connecting": "Connecting to satellite...",
  "satellite.nextImage.one": "Next image in {days} day ({date})",
  "satellite.nextImage.other": "Next image in {days} days ({date})",
  "ndvi.preEmergence": "Pre-Emergence",
  "toast.error": "Error",
  "toast.warning": "Warning",
  "toast.success": "Done",
  "toast.info": "Info",
  "help.title": "AGROPTIMIZER Guide",
  "help.placeholder": "Ask how to use the app...",
  "help.send": "Send",
  "help.greeting": "Hi! I'm your AGROPTIMIZER guide.\n\nI can help you with:\n• How to draw a field\n• What each tab shows\n• Running a simulation\n• Understanding satellite images\n• Anything else about the platform\n\nWhat do you need help with?",
  "login.title": "AGROPTIMIZER",
  "login.subtitle": "Field Intelligence",
  "login.tabLogin": "Login",
  "login.tabRegister": "Register",
  "login.email": "Email",
  "login.emailPlaceholder": "you{'@'}example.com",
  "login.password": "Password",
  "login.passwordPlaceholder": "••••••••",
  "login.loginBtn": "Login",
  "login.forgotPassword": "Forgot password?",
  "login.loggingIn": "Logging in...",
  "login.loginFailed": "Login failed",
  "register.email": "Email",
  "register.emailPlaceholder": "you{'@'}example.com",
  "register.password": "Password",
  "register.passwordPlaceholder": "Min. 8 characters",
  "register.confirmPassword": "Confirm Password",
  "register.confirmPlaceholder": "Repeat password",
  "register.createBtn": "Create Account",
  "register.creating": "Creating account...",
  "register.passwordMismatch": "Passwords do not match",
  "register.failed": "Registration failed",
  "forgot.description": "Enter your email and we'll send you a reset link.",
  "forgot.email": "Email",
  "forgot.emailPlaceholder": "you{'@'}example.com",
  "forgot.sendBtn": "Send Reset Link",
  "forgot.backToLogin": "← Back to Login",
  "forgot.sending": "Sending...",
  "forgot.sendFailed": "Failed to send reset email. Try again.",
  "forgot.linkSent": "Reset link sent.",
  "changePassword.title": "Change Password",
  "changePassword.currentPassword": "Current Password",
  "changePassword.currentPlaceholder": "••••••••",
  "changePassword.newPassword": "New Password",
  "changePassword.newPlaceholder": "Min. 8 characters",
  "changePassword.confirmPassword": "Confirm New Password",
  "changePassword.confirmPlaceholder": "Repeat new password",
  "changePassword.changeBtn": "Change Password",
  "changePassword.passwordMismatch": "Passwords do not match",
  "changePassword.saving": "Saving...",
  "changePassword.success": "Password changed! Redirecting...",
  "changePassword.failed": "Failed to change password",
  "validation.password.tooShort": "Password must be at least 12 characters.",
  "validation.password.tooLong": "Password must be at most 72 characters.",
  "validation.password.common": "This password is one of the most commonly-leaked passwords. Choose something more unique — a short phrase or sentence works well.",
  "validation.password.weak": "Password is not strong enough.",
  "validation.password.criterion.length": "At least 12 characters",
  "validation.password.criterion.notCommon": "Not a commonly-used password",
  "validation.password.show": "Show password",
  "validation.password.hide": "Hide password",
  "error.auth.invalidCredentials": "Invalid email or password",
  "error.auth.incorrectPassword": "Current password is incorrect",
  "error.auth.deleteConfirmationMismatch": "Type DELETE (in capital letters) to confirm.",
  "error.auth.externalAuth": "This account uses external authentication",
  "success.auth.accountDeleted": "Account deleted.",
  "success.auth.subscriptionCancelled": "Subscription cancelled.",
  "login.passwordRequired": "Password is required",
  "deleteAccount.title": "Delete Account",
  "deleteAccount.warning": "This will delete your account. Your fields, satellite monitoring, simulation runs, and chat history will be kept for 30 days in case you change your mind, then permanently removed. Log in again within 30 days to cancel the deletion.",
  "deleteAccount.typeToConfirm": "Type DELETE to confirm",
  "deleteAccount.deleteBtn": "Delete My Account",
  "deleteAccount.deleting": "Deleting...",
  "deleteAccount.failed": "Could not delete account.",
  "cancelSubscription.title": "Cancel Subscription",
  "cancelSubscription.body": "Your plan will switch back to the free tier. You can re-subscribe at any time and keep your fields and history.",
  "cancelSubscription.keepPlan": "Keep My Plan",
  "cancelSubscription.confirmBtn": "Confirm Cancel",
  "cancelSubscription.cancelling": "Cancelling...",
  "cancelSubscription.success": "Subscription cancelled.",
  "cancelSubscription.failed": "Could not cancel subscription.",
  "changePassword.samePassword": "Your new password must be different from your current password.",
  "changePassword.weakPassword": "Password is not strong enough.",
  "account.title": "My Account",
  "account.backToHome": "← Back to Home",
  "account.navLabel": "Account sections",
  "account.nav.profile": "Profile",
  "account.nav.security": "Security",
  "account.nav.billing": "Billing",
  "account.nav.dangerZone": "Danger Zone",
  "account.profile.lede": "Your account basics. Session-level preferences are set at login.",
  "account.profile.email": "Email",
  "account.profile.language": "Language",
  "account.profile.units": "Units",
  "account.profile.plan": "Plan",
  "account.profile.unitsImperial": "Imperial (acres, bu/ac)",
  "account.profile.unitsMetric": "Metric (ha, kg/ha)",
  "account.profile.planFree": "Free",
  "account.profile.languageChangeNote": "Pick the language you want for the app, emails, and the AI advisor. The change applies right away.",
  "account.profile.languageChangedToast": "Language updated.",
  "account.profile.languageChangeFailedToast": "Could not change your language. Try again.",
  "account.security.lede": "Update your password. Changing it will sign you out of other devices.",
  "account.billing.lede": "Your current subscription plan.",
  "account.billing.paidDescription": "You have full access to monitoring and advisory features.",
  "account.billing.freeDescription": "Basic access. Upgrade for extended monitoring and advisory features.",
  "account.billing.freeLede": "You are on the free plan.",
  "account.billing.cancelCopy": "Downgrade to the free plan. You can re-upgrade at any time.",
  "account.dangerZone.lede": "Irreversible actions. Double-check before you confirm.",
  "account.dangerZone.deleteDescription": "Schedules your account for permanent deletion. You have a 30-day grace period to restore it by contacting support.",
  "account.nav.connections": "Connected Accounts",
  "account.connections.lede": "Sign in faster by linking an external identity provider.",
  "account.connections.linked": "Linked",
  "account.connections.notLinked": "Not linked",
  "account.connections.linkGoogle": "Link Google",
  "account.connections.unlinkGoogle": "Disconnect Google",
  "account.connections.requiresVerifiedEmail": "Verify your email first to link a Google account.",
  "account.connections.linkSuccessToast": "Google linked successfully.",
  "account.connections.unlinkSuccessToast": "Google disconnected.",
  "account.connections.linkDialog.title": "Link your Google account",
  "account.connections.linkDialog.body": "Confirm your password to start linking your Google account. You will be redirected to Google to grant access.",
  "account.connections.linkDialog.password": "Current password",
  "account.connections.linkDialog.continue": "Continue to Google",
  "account.connections.linkDialog.linking": "Linking...",
  "account.connections.linkDialog.failed": "Could not start Google linking. Try again.",
  "account.connections.unlinkDialog.title": "Disconnect Google",
  "account.connections.unlinkDialog.titleEmail": "Confirm by email",
  "account.connections.unlinkDialog.bodyHybrid": "Confirm your password to disconnect Google from your account. You will continue to sign in with your email and password.",
  "account.connections.unlinkDialog.bodyGoogleOnly": "We'll send a confirmation link to your email. Click it to set a new password and disconnect Google. Without a password you would lose access to your account.",
  "account.connections.unlinkDialog.password": "Current password",
  "account.connections.unlinkDialog.confirm": "Disconnect",
  "account.connections.unlinkDialog.disconnecting": "Disconnecting...",
  "account.connections.unlinkDialog.sendEmail": "Send confirmation email",
  "account.connections.unlinkDialog.sending": "Sending...",
  "account.connections.unlinkDialog.emailSentToast": "We sent a confirmation link to your email.",
  "account.connections.unlinkDialog.failed": "Could not disconnect Google. Try again.",
  "account.connections.finalize.title": "Set a password and disconnect Google",
  "account.connections.finalize.body": "Set a password for your account. We will disconnect Google in the same step.",
  "account.connections.finalize.newPassword": "New password",
  "account.connections.finalize.confirmPassword": "Confirm new password",
  "account.connections.finalize.confirm": "Disconnect Google",
  "account.connections.finalize.submitting": "Disconnecting...",
  "account.connections.finalize.mismatch": "Passwords do not match.",
  "account.connections.finalize.weak": "Password is too weak.",
  "account.connections.finalize.failed": "Could not disconnect Google. Try again.",
  "common.cancel": "Cancel",
  "login.oauthOr": "or",
  "login.signInWithGoogle": "Sign in with Google",
  "login.emailVerifiedToast": "Email verified — thanks!",
  "login.emailVerifyFailedToast": "Verification link is invalid or has expired. Sign in to request a new one.",
  "login.oauthError.cancelled": "Google sign-in was cancelled.",
  "login.oauthError.state": "Sign-in session expired or invalid. Please try again.",
  "login.oauthError.token": "Could not complete Google sign-in. Please try again.",
  "login.oauthError.deactivated": "This account has been deactivated.",
  "login.oauthError.emailConflict": "An account with this email already exists. Sign in with email/password and link Google from your account settings.",
  "login.oauthError.googleUnverified": "Your Google account email is not verified. Verify it with Google first, then return here.",
  "login.oauthError.alreadyLinked": "This Google account is already linked to a different AGROPTIMIZER account.",
  "login.oauthError.linkToken": "Linking session expired or invalid. Confirm your password again and try again.",
  "login.oauthError.linkUnauthenticated": "Please sign in before linking a Google account.",
  "login.oauthError.linkTarget": "We could not find your account. Sign in again and try once more.",
  "login.oauthError.generic": "Could not sign in with Google. Please try again.",
  "emailVerify.banner.text": "We sent a verification link to your email. Verify your address to unlock account-linking.",
  "emailVerify.banner.resend": "Didn't receive it? Resend",
  "emailVerify.banner.sending": "Sending...",
  "emailVerify.banner.sent": "Sent — check your inbox",
  "emailVerify.banner.dismiss": "Dismiss",
  "emailVerify.banner.resentToast": "Verification email sent. Check your inbox.",
  "emailVerify.banner.resendFailed": "Could not send the verification email. Try again in a moment.",
  "errors.notFound": "The requested data could not be found.",
  "errors.server": "The server could not complete this request. Please try again.",
  "units.imperial.area": "ac",
  "units.imperial.yield": "bu/ac",
  "units.imperial.nutrient": "lb/ac",
  "units.imperial.seedingRate": "k/ac",
  "units.imperial.rowSpacing": "in",
  "units.imperial.costPerArea": "$/ac",
  "units.imperial.precipitation": "in",
  "units.imperial.temperature": "°F",
  "units.imperial.pricePerBu": "$/bu",
  "units.imperial.pricePerLb": "$/lb",
  "units.metric.area": "ha",
  "units.metric.yield": "kg/ha",
  "units.metric.nutrient": "kg/ha",
  "units.metric.seedingRate": "k/ha",
  "units.metric.rowSpacing": "cm",
  "units.metric.costPerArea": "$/ha",
  "units.metric.precipitation": "mm",
  "units.metric.temperature": "°C",
  "units.metric.pricePerBu": "$/t",
  "units.metric.pricePerLb": "$/kg",
  "crop.corn": "Corn",
  "crop.soybean": "Soybean",
  "error.auth.registrationFailed": "Registration failed. Please check your input or try a different email.",
  "error.auth.invalidRefreshToken": "Invalid or expired refresh token",
  "error.auth.invalidTokenType": "Invalid token type",
  "error.auth.invalidToken": "Invalid refresh token",
  "error.auth.userNotFound": "User not found",
  "error.auth.tokenRevoked": "Token has been revoked",
  "error.auth.resetLinkInvalid": "Reset link is invalid or has expired.",
  "error.field.notFound": "Field not found",
  "error.field.tooLarge": "Field too large ({acres} acres). Maximum allowed is {max_acres} acres per field.",
  "error.job.notFound": "Job not found",
  "error.job.notCancelable": "Job with status {status} cannot be canceled.",
  "error.sim.fieldNotFound": "Field not found",
  "error.sim.tooManyJobs": "Too many jobs in progress ({count}). Please wait for current jobs to finish.",
  "error.sim.resultNotFound": "Simulation result not found",
  "error.ndvi.fieldNotFound": "Field not found",
  "error.ndvi.cooldown": "Fetched {days_since}d ago. Sentinel-2 revisit is ~5 days — next fetch available {next_date}.",
  "error.ndvi.invalidDate": "Invalid date format. Use YYYY-MM-DD.",
  "error.ndvi.imageNotAvailable": "Image not available for this date.",
  "error.ndvi.imageCleanedUp": "Image file has been cleaned up.",
  "error.ndvi.invalidMonitoringDays": "Monitoring days must be between {min_days} and {max_days}.",
  "error.market.fieldNotFound": "Field not found",
  "error.market.contractNotFound": "Contract not found",
  "error.llm.fieldNotFound": "Field not found or access denied.",
  "error.llm.threadNotFound": "Chat thread not found or access denied.",
  "error.llm.helpUnavailable": "Help chat temporarily unavailable.",
  "error.rateLimit.tooMany": "Too many requests. Please wait a minute.",
  "error.rateLimit.auth": "Too many attempts. Please wait a minute.",
  "success.auth.passwordChanged": "Password changed successfully",
  "success.auth.loggedOut": "Logged out successfully",
  "success.auth.resetLinkSent": "If that email is registered, a reset link has been sent.",
  "success.auth.passwordReset": "Password reset successfully. You can now log in.",
  "success.ndvi.jobInProgress": "A satellite analysis job is already in progress for this field.",
  "success.ndvi.monitoringStopped": "Monitoring stopped successfully.",
  "success.ndvi.noMonitoring": "No active monitoring found.",
  "success.market.refreshQueued": "All market & AMS data fetching tasks queued successfully.",
  "status.job.started": "Started",
  "status.job.complete": "Complete",
  "status.job.retryingGeneric": "Retrying",
  "status.job.failedGeneric": "Job failed. Please try again.",
  "status.ndvi.noImagery": "No clear imagery found in the recent window.",
  "common.unknown": "Unknown",
  "fields.loading": "Loading fields...",
  "fields.empty": "No fields yet. Draw a boundary to create one.",
  "fields.rename": "Rename",
  "fields.delete": "Delete",
  "fields.renamePrompt": "Enter a new name for this field:",
  "fields.deleteConfirm": "Are you sure you want to delete \"{name}\"?",
  "kpi.estYield": "Est. Yield",
  "kpi.estProfit": "Est. Profit",
  "kpi.fieldHealth": "Field Health",
  "kpi.lastCaptured": "Last Captured",
  "kpi.growthSignal": "Growth signal",
  "kpi.today": "Today",
  "kpi.dayAgo": "1 day ago",
  "kpi.daysAgo": "{n} days ago",
  "kpi.ariaBreakeven": "Break-even margin {value}",
  "kpi.marginTooltip": "Margin per bushel is what you make on each bushel after covering your costs. It's your crop price minus your breakeven price. Breakeven is your total cost per acre divided by your expected yield.",
  "advisor.you": "You",
  "advisor.replyUnavailable": "Sorry, I could not generate a response.",
  "advisor.replyFailed": "Sorry, something went wrong while generating a response. Please try again.",
  "advisor.replyError": "Sorry, an error occurred. Please try again.",
  "satellite.condition": "Condition",
  "satellite.daysAfterPlantingShort": "DAP",
  "satellite.ndviUpdatedNudge": "Satellite imagery updated for this field. Latest observation: vegetation greenness={mean}, condition=\"{label}\". Ask me anything about your crop health or greenness trends.",
  "help.open": "Open help",
  "help.errorReply": "Sorry, something went wrong. Please try again.",
  "login.success": "Logged in successfully.",
  "register.success": "Account created successfully.",
  "market.breakeven.margin": "Margin",
  "common.maxShort": "Max",
  "simulation.submitting": "Submitting simulation...",
  "simulation.running": "Running simulation...",
  "simulation.loadingResults": "Loading results...",
  "satellite.noField": "No Field Selected",
  "satellite.today": "Today",
  "satellite.oneDayAgo": "1 day ago",
  "satellite.daysAgo": "{n} days ago",
  "satellite.monitoringWaitHint": "Monitoring will load imagery automatically when a new scene is available.",
  "home.title": "Your Fields",
  "home.subtitle": "Which field needs attention?",
  "home.mapTitle": "Fields map",
  "home.mapAriaLabel": "Overview map of your fields",
  "home.lastObserved": "Last image {date}",
  "home.noObservation": "No observation yet",
  "home.status.stall_detected": "Stall detected — open the map to check {area} flagged since the previous image",
  "home.status.on_track": "Crop health looks good",
  "home.status.monitoring_active": "Monitoring active — waiting for trend data",
  "home.status.stale": "No clear image in {n} days — check back soon",
  "home.status.no_observations": "Waiting for first satellite image",
  "home.status.low_confidence": "Recent image partially cloudy — limited view",
  "home.empty.title": "Add your first field to get started",
  "home.empty.subtitle": "Draw a boundary on the satellite map to create a field.",
  "home.empty.action": "Create Field",
  "home.loading": "Loading fields...",
  "home.loadError": "Could not load fields. Please try again.",
  "home.newField": "+ New Field",
  "home.totalArea": "Total: {area} across {n} fields",
  "field.created": "Field created successfully",
  "field.createFailed": "Failed to create field",
  "welcome.drawingHint": "Click on the map to place vertices. Click the first point to close the polygon.",
  "login.invalidEmail": "Invalid email format",
  "login.lockedOut": "Try again in {seconds}s",
  "satellite.growthFromPrevToSelected": "Growth from {prev} to {selected}",
  "satellite.ndviTimeSeries": "NDVI Time Series",
  "sidebar.toggle": "Toggle menu",
  "common.yes": "Yes",
  "params.foliarFertAppCost": "Foliar Fertilizer Application",
  "advisor.sidebar.title": "Conversations",
  "advisor.sidebar.aria": "Conversations",
  "advisor.sidebar.sims": "Simulations",
  "advisor.sidebar.images": "Images",
  "advisor.sidebar.untitled": "Untitled simulation",
  "advisor.sidebar.untitledSeason": "Untitled season",
  "advisor.sidebar.rename": "Rename",
  "advisor.sidebar.delete": "Delete",
  "advisor.sidebar.confirmDelete": "Delete?",
  "advisor.sidebar.empty": "Run a simulation or click \"Ask Advisor about this image\" to start a conversation.",
  "advisor.relTime.justNow": "just now",
  "advisor.relTime.minutesAgo": "{n}m ago",
  "advisor.relTime.hoursAgo": "{n}h ago",
  "advisor.relTime.daysAgo": "{n}d ago",
  "advisor.divider.simFallback": "Simulation",
  "advisor.divider.imageFallback": "Image",
  "advisor.inputGate.preData": "Run a simulation or click \"Ask Advisor about this image\" to start a conversation.",
  "advisor.openRail": "Open conversations",
  "reset.description": "Set a new password for your account.",
  "reset.newPassword": "New password",
  "reset.confirmPassword": "Confirm new password",
  "reset.confirmPlaceholder": "Repeat new password",
  "reset.submit": "Set New Password",
  "reset.submitting": "Updating...",
  "reset.success": "Password updated. Please log in with your new password.",
  "reset.failed": "Could not reset password. The link may have expired — request a new one.",
  "reset.tokenMissing": "Reset link is missing or invalid. Request a new one.",
  "validation.password.criteriaLabel": "Password requirements"
}
